import { useTranslation } from "react-i18next";
import {
  Tooltip,
  TooltipTrigger,
  TooltipContent,
} from "@/components/ui/tooltip";

export const TopHeader: React.FC = () => {
  const { t } = useTranslation("common");
  return (
    <div className="bg-white border-b border-gray-200 px-4 py-2 flex items-center justify-between">
      {/* Logo on the left */}
      <a
        href="#"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="home"
        className="flex items-center"
      >
        <img
          src="/wapen-utrecht-rood.svg"
          alt="Gemeente Utrecht logo"
          className="h-12 w-auto"
        />
      </a>

      {/* Help tooltip on the right */}
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            className="text-[#cc0000] hover:underline font-medium text-base cursor-pointer"
            aria-label="Help"
          >
            ?
          </button>
        </TooltipTrigger>
        <TooltipContent side="bottom">
          <p>{t("tooltips.help")}</p>
        </TooltipContent>
      </Tooltip>
    </div>
  );
};
